/*jslint browser */
/*global process */

var $ = jQuery;

/**
 *
 */
export default class QuantityChangerController
{
    private _quantityMinus: JQuery
    private _quantityPlus: JQuery
    private _quantityInput: JQuery

    constructor()
    {

    }

    public quantityChangerAction(): void
    {
        this.registerEvents();
    }

    /**
     *
     * @private
     */
    private registerEvents(): void
    {
        this._quantityMinus = $('.quantity-minus');
        this._quantityPlus = $('.quantity-plus');
        this._quantityInput = $('.quantity-input');

        this._quantityMinus.on('click', (e) => {
            this.quantityMinusClick($(e.currentTarget));
        })

        this._quantityPlus.on('click', (e) => {
            this.quantityPlusClick($(e.currentTarget));
        })

        this._quantityInput.on('change', (e) => {
            this.quantityInputChange($(e.currentTarget));
        })
    }

    private quantityMinusClick(ob: JQuery): void {
        const val = this._quantityInput.val() as number;
        this._quantityInput.val(val - 1);
        this._quantityInput.trigger('change');
    }

    private quantityPlusClick(ob: JQuery): void {
        const val = this._quantityInput.val() as string;
        const newVal = parseInt(val) + 1;
        this._quantityInput.val(newVal);
        this._quantityInput.trigger('change');
    }

    private quantityInputChange(ob: JQuery): void {
        const val = this._quantityInput.val() as number;
        if(val < 1) {
            this._quantityInput.val(1);
        }
    }
}